<template>
  <div
    class="faces-panel"
  >
    <div
     class="faces-panel__header text-caption text-grey-6 q-px-sm q-pt-sm q-pb-xs"
    >
      Faces
    </div>

    <q-linear-progress v-if="isLoading" indeterminate color="primary" />

    <div
     class="faces-panel__grid q-pa-sm"
    >
      <PersonFaceItem
        v-for="face in faces"
        :key="face.id"
        :face="face"
        :client-id="clientId"
        :selected="selectedId === face.id"
        @select="toggle(face.id)"
        @reassigned="onRemoved(face.id)"
        @deleted="onRemoved(face.id)"
      />
    </div>

    <div
      v-if="!isLoading && faces.length === 0"
      class="text-caption text-grey-5 q-pa-sm text-center"
    >
      No faces
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { QueryResult } from '@/type';
import { Face } from '@/analysis/types';
import { HasTaskMixin } from '@/mixins';
import faceRepository from '@/analysis/face/face-repository';
import PersonFaceItem from './PersonFaceItem.vue';

interface Data {
  faces: Face[];
  selectedId: number | null;
}

export default defineComponent({
  emits: ['filter'],
  mixins: [HasTaskMixin],
  components: { PersonFaceItem },
  props: {
    clientId: {
      type: Number,
      required: true,
    },
    personId: {
      type: Number,
      required: true,
    },
  },
  data(): Data {
    return {
      faces: [],
      selectedId: null,
    };
  },
  watch: {
    personId: {
      immediate: true,
      handler() {
        this.load();
      },
    },
  },
  methods: {
    async load() {
      this.selectedId = null;
      this.task = faceRepository.findAll(this.clientId, {
        personId: this.personId,
        limit: 100,
      });
      this.task.then((result: QueryResult<Face>) => {
        this.faces = result.items;
      });
    },
    toggle(faceId: number) {
      this.selectedId = this.selectedId === faceId ? null : faceId;
      this.$emit('filter', this.selectedId);
    },
    onRemoved(faceId: number) {
      this.faces = this.faces.filter(f => f.id !== faceId);
      if (this.selectedId === faceId) {
        this.selectedId = null;
        this.$emit('filter', null);
      }
    },
  },
});
</script>

<style scoped>
.faces-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.faces-panel__header {
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 1px solid #f0f0f0;
  flex-shrink: 0;
}

.faces-panel__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  justify-items: center;
}
</style>
